import { useEffect, useState } from "react";
import { CloudDownload } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, apiError } from "@/lib/api";
import { formatDate } from "@/lib/format";
import { kb } from "@/components/settings/backup/util";

// Ortam taşıma: S3'teki şifreli yedeği (ör. preview'dan alınan) bu ortamın canlı DB'sine geri yükler
export function S3ImportCard({ onDone }) {
  const [items, setItems] = useState(null);
  const [err, setErr] = useState("");
  const [pick, setPick] = useState(null);
  const [text, setText] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/backup/s3-list").then(({ data }) => setItems(data.items)).catch((e) => setErr(apiError(e)));
  useEffect(() => { load(); }, []);
  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/backup/s3-restore", { key: pick.key, confirm_text: text, password: pw });
      toast.success(`${data.backup} geri yüklendi · ${data.documents} belge`);
      setPick(null); onDone?.();
    } catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };
  return (
    <div className="panel p-4" data-testid="s3-import-card">
      <div className="font-semibold text-[13px] flex items-center gap-2"><CloudDownload className="h-4 w-4" />S3'ten Geri Yükle (ortam taşıma)</div>
      <p className="text-[12px] text-slate-500 mt-1">Başka ortamda (ör. preview) alınmış ve S3'e yüklenmiş yedeği bu ortamın canlı veritabanına yükler. Önce güvenlik yedeği alınır.</p>
      {err && <div className="text-[12px] text-rose-700 mt-2">{err}</div>}
      <div className="max-h-56 overflow-auto mt-2 border rounded">
        <table className="erp-table text-[12px]"><tbody>
          {(items || []).map((o) => <tr key={o.key} data-testid="s3-import-row">
            <td className="font-mono">{o.key.replace("backups/", "")}</td><td>{kb(o.size)}</td><td>{formatDate(o.modified)}</td>
            <td><Button size="sm" variant="outline" className="h-7" onClick={() => { setPick(o); setText(""); setPw(""); }} data-testid="s3-import-pick">Bu yedeği yükle</Button></td></tr>)}
          {items && !items.length && <tr><td className="text-slate-400">S3'te yedek yok</td></tr>}
        </tbody></table>
      </div>
      {pick && <Dialog open onOpenChange={(v) => !v && !busy && setPick(null)}>
        <DialogContent className="max-w-lg" data-testid="s3-import-dialog">
          <DialogHeader><DialogTitle className="text-rose-700">S3 yedeğini canlı veritabanına yükle</DialogTitle>
            <DialogDescription>{pick.key} · mevcut tüm iş verileri bu yedekle değiştirilir.</DialogDescription></DialogHeader>
          <div className="space-y-2">
            <Input placeholder="Onay için GERİ YÜKLE yazın" value={text} onChange={(e) => setText(e.target.value)} data-testid="s3-import-confirm" />
            <Input type="password" placeholder="Şifreniz" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="s3-import-password" />
          </div>
          <DialogFooter><Button variant="outline" disabled={busy} onClick={() => setPick(null)}>Vazgeç</Button>
            <Button className="bg-rose-600 hover:bg-rose-700" disabled={busy || text.trim() !== "GERİ YÜKLE" || !pw} onClick={run} data-testid="s3-import-submit">{busy ? "Yükleniyor…" : "Geri Yükle"}</Button></DialogFooter>
        </DialogContent>
      </Dialog>}
    </div>
  );
}
